"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveAccountSegmentEndpoint = exports.AddAccountSegmentEndpoint = void 0;
exports.AddAccountSegmentEndpoint = require("./add-account-segment");
exports.RemoveAccountSegmentEndpoint = require("./remove-account-segment");
